import { render, staticRenderFns } from "./ApproveCase.vue?vue&type=template&id=6dcf120a"
import script from "./ApproveCase.vue?vue&type=script&lang=js"
export * from "./ApproveCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports